/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2026-01-29 10:21:24
 */
import React, { useEffect, useRef } from 'react'
import { Button } from 'antd'
import {
  useAppDispatch,
  useAppSelector,
  usePathValue,
  usePayment
} from '../../../app/hooks'
import sensors from '../../../utils/sensors'
import crown_btn_icon from '../../../images/btn-crown-icon.png'
import { setDownloadSettingModalVisible } from '../../../actions/main'
import priceIcon1 from './assets/price_0.1.png'
import { SettingOutlined } from '@ant-design/icons'

const Footer = (props) => {
  const { namingRule, onOk, onDownloadOnce, disableBatchDownload } = props
  const dispatch = useAppDispatch()
  const isDesktop = useAppSelector((state) => state.main.isDesktop)
  const groupID = useAppSelector((state) => state.group.groupId)
  const isVip = useAppSelector((state) => state.group.isVip)
  const limitInfo = useAppSelector((state) => state.groupLimit.limitInfo)
  const pathValue = usePathValue()
  const isVipRef = useRef(isVip)
  const payment = usePayment()
  const abTestConfig = useAppSelector((state) => state.main.abTestConfig)
  const chargePage = !!abTestConfig?.groupWebVipAB?.chargePage

  const onPay = () => {
    sensors.track('web_click_button_workgroup_go_vip_trigger', {
      place: pathValue,
      functionType: 'photoDownload',
      groupID
    })

    payment.open('allPhotoDownloadPhoto')
  }

  const handleOpenDownloadSetting = () => {
    dispatch(setDownloadSettingModalVisible(true))
  }

  const handleOKClick = () => {
    if (isVip) {
      onOk()
    } else {
      onPay()
    }
  }

  const handleBatchDownload = () => {
    if (isVip) {
      onOk('downloadOnce')
    } else {
      onDownloadOnce()
    }
  }

  useEffect(() => {
    if (isVip && isVipRef.current !== isVip) {
      onOk()
    }
    isVipRef.current = isVip
  }, [isVip])

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <span>
        {isDesktop && (
          <Button onClick={handleOpenDownloadSetting}>
            <SettingOutlined />
            默认下载位置
          </Button>
        )}
      </span>
      <span>
        <Button
          id="batchDownloadBtn"
          style={{ visibility: 'hidden', width: '0px' }}
          onClick={() => {
            onOk('downloadOnce')
          }}
        >
          单次下载照片的按钮（隐藏状态）
        </Button>
        {!isVip &&
          !limitInfo?.photoViewLimit?.exist &&
          !disableBatchDownload &&
          !chargePage && ( // 命中照片查看限制或外部标记，不允许按张下载，chargePage 时不展示
            <Button
              style={{
                position: 'relative',
                width: '106px',
                marginRight: '2px'
              }}
              onClick={() => {
                handleBatchDownload()
              }}
            >
              按张下载
              <img
                src={priceIcon1}
                alt=""
                style={{
                  width: '66px',
                  height: '19px',
                  position: 'absolute',
                  right: -7,
                  top: -13
                }}
              />
            </Button>
          )}
        <Button
          type="primary"
          disabled={namingRule.length === 0}
          onClick={() => handleOKClick()}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            position: 'relative'
          }}
        >
          会员免费下载
          <img
            style={{ width: 20, marginLeft: 8 }}
            src={crown_btn_icon}
            alt=""
          />
        </Button>
      </span>
    </div>
  )
}

export default Footer
